export const preparedDashboardTexts = [
  'Getting a grip on the Grip',
  'Waking up the Gaffer',
  "Pulling the director's chair out of the storage room",
  'Sweeping the cobwebs off the stage floor',
  'Wiping down the dashboard panels',
  'Putting the finishing touches on the rendering',
  'Rehearsing some lines with the actors',
  'Scouting out the next shoot location',
  'Loading the tripods in the back of the van',
  'Waiting for the lighting crew to adjust the key light',
  'Helping the boom operator hold the mic overhead',
  'Ironing a wrinkle on one of the costumes',
  'Setting up the lights',
  'Checking the audio levels on the mixer',
  'Looking for a continuity error',
  'Framing the shot',
  'Going over the schedule with the assistant director',
  'Arranging furniture with the set director',
  'Trying to get all the extras into place',
  'Reviewing the shot list',
  'Writing down director feedback',
  'Organizing the props table',
  'Working with catering to deliver snacks to the crew',
  'Making sure the lens is clean',
  'Waiting for the paint to dry on set',
  'Checking the call sheet',
  'Replacing the batteries on the walkie-talkies',
  'Doing a touch up before the next scene',
  'Adjusting the rigging',
  'Marking the scene for the slate',
  'Gelling the lights for color correction',
  'Checking the boom mic placement',
  'Adjusting the camera focus',
  'Seeing if we need to audition new actors',
  'Sewing a quick fix on set',
  'Asking the camera assistant to check the film stock',
  'Stress testing the crane for the next shot',
  'Doing a make up change between scenes',
  'Cleaning and prepping props for the next scene',
  'Adjusting light temperatures',
  'Working on the new backdrop',
  'Switching scene partners',
  'Finding the script',
]
